export const LOAD_CHECKOUT_STATUS = 'LOAD_CHECKOUT_STATUS'
